var urlApiPAT="";
let ambiente="";
let enlace="";
const url = window.location.href;
if (url.includes('localhost')){
	ambiente = "local";
}
else if (url.includes('-int.mides.gub.uy/')){
	ambiente = "integracion";
}

else if (url.includes('-prep.mides.gub.uy/')){
	ambiente = "pre";
}
else {
	ambiente = "produccion";
}


switch (ambiente) {
case "local":
	urlApiPAT="https://apipat-int.mides.gub.uy/graphql";
	enlace = '';
	break;
case "integracion":
	urlApiPAT="https://apipat-int.mides.gub.uy/graphql";
	enlace = '';
	break;
case "pre":
	urlApiPAT="https://apipat-prep.mides.gub.uy/graphql";
	enlace = '';
	break;
case "produccion":
	urlApiPAT="https://apipat.mides.gub.uy/graphql";
	enlace = '';
	break;
}

/*URL para registro genérico de TUID*/
var tuIDRegistroURL="https://www.tuid.uy/user/users/selfRegistration/dorso?sourceClientUrn=urn:tuid:clientid:autoregistro:tuid";
var tuIDLOGIN="https://eidas.tuid-preproduccion.uy/trustedx-authserver/oauth/as-principal?response_type=code&client_id=urn:tuid:clientid:Mides&redirect_uri="+enlace+"&scope=attributes+profile";

exports.urlApiPAT = urlApiPAT;
exports.tuIDRegistroURL = tuIDRegistroURL;
exports.tuIDLOGIN = tuIDLOGIN;